import {useParams, useRouteMatch} from 'react-router-dom';
import {UserPlaylists} from '../../../../../../../components/user-playlists/user-playlists';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../i18n/translations';
import {ScreenPaths} from '../../../../../../../enums';
import {CaregiverPathExtensions} from '../../../../../../../components/caregiver-routes/caregiver-routes';

export default function ProfessionalCaregiverPlaylistsProfessionalCaregiverOfficeScreen({
  canWrite,
}: {
  canWrite: boolean;
}) {
  const {t} = useTranslation();
  const officeContext = useOffice();
  let {id, entityId}: {id?: string; entityId?: string} = useParams();
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <UserPlaylists
      caregiverMode={CaregiverMode.Professional}
      canWrite={canWrite}
      userId={id || ''}
      entityId={entityId || ''}
      userName={
        officeContext.state.userForm?.user.displayName ||
        officeContext.state.userForm?.user.name ||
        ''
      }
      playlistRowBaseLinkUrl={url}
      headerTitleCrumbs={[
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs.team
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs
              .professionals
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label:
            officeContext.state.userForm?.user.displayName ||
            officeContext.state.userForm?.user.name ||
            '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}/${id}/${CaregiverPathExtensions.Profile}`,
        },
        {
          label: t(translations.screen_paths.senior_playlists),
          link: url,
        },
      ]}
    />
  );
}
